exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-deal-overlay{align-items:center;background-color:#a2212d;border-radius:30px;bottom:-5px;box-shadow:2px 2px 3px 0 rgba(0,0,0,0.2);color:#fff;display:flex;font-weight:600;height:60px;justify-content:center;position:absolute;right:-5px;width:60px}@media (max-width: 480px){.book-deal-overlay{bottom:10px;height:50px;right:10px;width:50px}}\n", ""]);

// exports
exports.locals = {
	"book-deal-overlay": "book-deal-overlay"
};